export class AppConstantModel {
    Return_URL: string;
    Customer_URL: string;
    IsMP:string;
    apiUrl: string;
    UserEmail: string;

    constructor(){
        this.IsMP ="0";
    }
}